import { html, nothing } from 'lit';
import { PurposeType } from '@common/types/enum';
import { Purpose } from '@common/types/model';
import type { TefComs4cs4p } from '@src/components/TefComs4cs4p';
import { consentStore } from '@src/store';

export const renderSinglePurposeConsents = (component: TefComs4cs4p, purpose: Purpose) : ReturnType<typeof html>[] => {
  let subscriptionsHtml = [html`${nothing}`];

  if (purpose.purposeType === PurposeType.identifier_bound && purpose.subscriptions) {
    subscriptionsHtml = purpose.subscriptions.map((subscription) => component.getTemplateFn('singleSubscription')(subscription));
  } else if (purpose.purposeType === PurposeType.user_bound) {
    subscriptionsHtml = [component.getTemplateFn('singlePurposeUserBound')(purpose)];
  }

  return subscriptionsHtml;
};

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
//
export const singlePurpose = function render(this: TefComs4cs4p, purpose : Purpose) : ReturnType<typeof html> {
  // Currently the data in admin4p.purpose is all mixed up.
  // We need the shortest description here so we need to compare values
  const shorterDescription = purpose.shortDescription && purpose.shortDescription.length < purpose.description.length
    ? purpose.shortDescription : purpose.description;

  return html`
    <div class="slide" data-testid="${purpose.title}">
      <div>
        <div class="container border">
          <div class="typography-display--5 u-st--default">${purpose.title}</div>
          <p class="purpose-description">${shorterDescription}</p>
        </div>
        ${renderSinglePurposeConsents(this, purpose)}

        <hr class="divider divider--size-flat" />

        <div class="col row align-items-center u-st--default">
          <tef-coms-button
            text="'${purpose.title}' deaktivieren"
            data-purpose-id=${purpose.purposeId}
            @click=${this.withdrawConsentForAllMsisdnsForPurpose}
            .disabled=${!consentStore.hasAnyGrantedConsentsForPurposeId(purpose.purposeId)}></tef-coms-button>
         </div>
      </div>
    </div>
  `;
};
